export enum Display {
	List = "List",
	Table = "Table",
	Kanban = "Kanban",
}
